/* eslint-disable camelcase */
import { KPI_TYPE } from '../../HotAlerts/hotAlertsInterface';
import { SurveyDefaultDatePeriod, SurveyStatus, SurveyTemporalFilterType } from '../../Surveys/surveyInterface';

export interface SelectedSurveyProps {
    id: number,
    name: string,
    description: string,
}

export interface SurveyModalProps {
    survey: SelectedSurveyProps
    selectedSurveyId?: number
    handleSelectedSurvey: (survey: SelectedSurveyProps) => void
}

export interface PersonalizedSurveyProps {
    id: number,
    shortName: string,
    name: string,
    display: boolean,
    status: SurveyStatus,
    updateDate: Date,
    schema: string,
    temporalFilterType: SurveyTemporalFilterType,
    defaultDatePeriod: SurveyDefaultDatePeriod,
    context: string,
    hasDashboard: boolean,
    hasHotAlert: boolean,
    hasToAnonymateData: boolean,
    anonymateDays?: number,
    hasAutomaticSynchronization: boolean,
}

export type QuestionType = 'Single' | 'Multiple' | 'Open' | 'Date' | 'Chapter' | 'Loop' | 'DateTime' | 'Numeric';

export interface SurveyQuestionDetailResponse {
    id: number,
    deleted: boolean,
    entrycode: string,
    isexclusive: boolean,
    maincaption: string,
    scaledresponse: number | null,
    rank: number,
}

export interface SurveyQuestionDetail {
    maincaption: string,
    analysecaption: string,
    linkedquestionid: number,
    maxresponsecount?: number,
    ismultiple: boolean,
    visibility: boolean,
    type: QuestionType,
    linktype?: number,
    allownoresponse: boolean,
    responses: SurveyQuestionDetailResponse[],
    hasnumericvalues: boolean,
    parentid: number,
}

export interface SurveyQuestion {
    id: number,
    shortcut: string,
    details: SurveyQuestionDetail,
    rank: number,
    isloopitem: boolean,
}

export interface SelectedQuestionResponseSettings {
    id: number,
    excluded: boolean,
    maincaption: string,
    scaledresponse: number | null,
}

export interface SelectedQuestionSettings {
    hasNominalData: boolean,
    hasNumericValues: boolean,
    isExportable: boolean,
    isNps: boolean,
    responses: SelectedQuestionResponseSettings[],
    usableForQuartiles: boolean,
    isDate: boolean,
    hasInitWithLastValue: boolean,
}

export const createDefaultSettings = (question: SurveyQuestion): SelectedQuestionSettings => ({
    hasNominalData: false,
    hasNumericValues: question.details.hasnumericvalues,
    isExportable: true,
    isNps: false,
    responses: question.details.responses.map((r) => ({
        excluded: false,
        id: r.id,
        maincaption: r.maincaption,
        scaledresponse: r.scaledresponse,
    })),
    usableForQuartiles: false,
    isDate: false,
    hasInitWithLastValue: false,
});

export interface SelectedQuestion {
    question: SurveyQuestion,
    customName: string,
    settings: SelectedQuestionSettings,
}

export interface HotAlertStatusColorConfig {
    color: string;
    fontColor: string;
}

export interface HotAlertStatusConfigItem {
    id?: number;
    tempId: string;
    label: string;
    isDefault: boolean;
    isFinal: boolean;
    colors: HotAlertStatusColorConfig;
}

export interface ConfiguratedHotAlertsSatisfaction {
    questionId: number;
    type: KPI_TYPE;
    positiveModalityIds: number[];
    negativeModalityIds: number[];
}

export interface ConfiguratedHotAlerts {
    openedQuestion?: number;
    firstName?: number;
    lastName?: number;
    phone?: number;
    mail?: number;
    satisfaction?: ConfiguratedHotAlertsSatisfaction;
    additionalQuestion: number[];
    detailQuestions: number[];
    statuses: HotAlertStatusConfigItem[];
}
